import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { getCurrentAccount } from "@/shared/utils/sessionStorage.utils";
import { NectarStatus } from "@/shared/enums/status.enum";
export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  const status = getCurrentAccount()?.accessStatus || null;
  if (to.name === "login") {
    next();
  } else if (to.name !== "accountSetup" && status === NectarStatus.NEW) {
    next({ name: "accountSetup" });
    return;
  } else {
    next();
  }
};
